export default "__VITE_ASSET__DTOpsueK__"